
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.idb-slot-item {

    margin-top: 0.75rem;

    display: flex;

    width: -moz-fit-content;

    width: fit-content;

    flex-direction: column;

    row-gap: 0.75rem
}

@media (min-width: 768px) {

    .idb-slot-item {

        margin-top: 0px
    }
}

.idb-slot-item.mobile-center, .idb-slot-item.mobile-left, .idb-slot-item.mobile-right {

    margin-left: auto;

    margin-right: auto;

    width: 250px
}

@media (min-width: 768px) {

    .idb-slot-item.mobile-center, .idb-slot-item.mobile-left, .idb-slot-item.mobile-right {

        margin-left: 0px;

        margin-right: 0px
    }

    .idb-slot-item.mobile-center, .idb-slot-item.mobile-left, .idb-slot-item.mobile-right {

        width: -moz-max-content;

        width: max-content
    }

    .idb-slot-item.mobile-center, .idb-slot-item.mobile-left, .idb-slot-item.mobile-right {

        width: -moz-fit-content;

        width: fit-content
    }
}

.idb-slot-item.mobile-center {

    align-items: center;

    text-align: center
}

.idb-slot-item.mobile-left {

    align-items: flex-start;

    text-align: left
}

.idb-slot-item.mobile-right {

    align-items: flex-end;

    text-align: right
}

.idb-slot-item--heading {

    font-weight: var(--fw-semibold);

    text-transform: uppercase;

    color: var(--blue-responsible-darken-1)
}

::slotted(*) {

    display: flex;

    padding-left: 0.5rem;

    font-size: var(--fs-sm);

    line-height: var(--lh-sm);

    color: var(--blue-responsible-darken-1)
}

@media (min-width: 768px) {

    ::slotted(*) {

        padding-left: 0px
    }
}

::slotted(img), ::slotted(svg) {

    margin-left: 0.5rem !important;

    display: block !important;

    height: 115px !important;

    width: 115px !important;

    border-radius: 9999px !important;

    object-fit: cover !important;

    padding-left: 0px !important;

    --tw-shadow: 0px 4px 14px 0px rgb(0, 0, 0, 0.1) !important;

    --tw-shadow-colored: 0px 4px 14px 0px var(--tw-shadow-color) !important;

    box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow) !important;

    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important
}

@media (min-width: 768px) {

    ::slotted(img), ::slotted(svg) {

        margin-left: 0px !important
    }

    ::slotted(img), ::slotted(svg) {

        height: 140px !important
    }

    ::slotted(img), ::slotted(svg) {

        width: 140px !important
    }
}

.idb-slot-item.mobile-center ::slotted(*), .idb-slot-item.mobile-left ::slotted(*), .idb-slot-item.mobile-right ::slotted(*) {

    margin-left: auto;

    margin-right: auto;

    width: -moz-max-content;

    width: max-content;

    padding-left: 0px;

    font-size: var(--fs-sm);

    line-height: var(--lh-sm);

    color: var(--blue-responsible-darken-1)
}

@media (min-width: 768px) {

    .idb-slot-item.mobile-center ::slotted(*), .idb-slot-item.mobile-left ::slotted(*), .idb-slot-item.mobile-right ::slotted(*) {

        margin-left: 0px;

        margin-right: 0px
    }

    .idb-slot-item.mobile-center ::slotted(*), .idb-slot-item.mobile-left ::slotted(*), .idb-slot-item.mobile-right ::slotted(*) {

        width: -moz-fit-content;

        width: fit-content
    }
}

.idb-slot-item.mobile-center ::slotted(img), .idb-slot-item.mobile-center ::slotted(svg), .idb-slot-item.mobile-left ::slotted(img), .idb-slot-item.mobile-left ::slotted(svg), .idb-slot-item.mobile-right ::slotted(img), .idb-slot-item.mobile-right ::slotted(svg) {

    margin-left: 0px;

    margin-right: 0px
}

.idb-slot-item.mobile-center ::slotted(*) {

    align-items: center;

    text-align: center
}

.idb-slot-item.mobile-left ::slotted(*) {

    align-items: flex-start;

    text-align: left
}

.idb-slot-item.mobile-right ::slotted(*) {

    align-items: flex-end;

    text-align: right
}

.idb-slot-item.mobile-center ::slotted(p), .idb-slot-item.mobile-left ::slotted(p), .idb-slot-item.mobile-right ::slotted(p) {

    max-width: 100%
}
`;